<template>
  <b-card>
    <h4 class="media-heading mb-0 titulo-microtask mb-3">
      Ingresar token
    </h4>
    <b-form-group>
      <b-form-input
        id="basicInput"
        v-model="token"
        placeholder="Enter Email"
      />
    </b-form-group>
    <b-button
      variant="primary"
      pill
      @click="guardartoken()"
    >
      Agregar
    </b-button>
  </b-card>
</template>
<script>
import {
  BCard, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BButton,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      token: '',
    }
  },
  methods: {
    guardartoken() {
      this.setCookie('token', this.token, 1)
      this.$router.push({ name: 'home' })
    },
    setCookie(cname, cvalue, exdays) {
      const d = new Date()
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
      const expires = `expires=${d.toUTCString()}`
      document.cookie = `${cname}=${cvalue};${expires};path=/`
    },
  },

}
</script>
